/**
 * fourFortyGlDocumentActions.js
 * Created by calhosh on 9/16/2021.
 */
import {SET_CHANGE_REASON_REQUIRED, SHOW_CHANGE_REASON_MODAL} from '../actiontypes';

export const setIsChangeReasonRequired = (isChangeReasonRequired, showChangeReasonModal, entityUid) => {
	return {
		type: SET_CHANGE_REASON_REQUIRED,
		isChangeReasonRequired: isChangeReasonRequired,
		showChangeReasonModal: showChangeReasonModal,
		entityUid: entityUid
	};
};

export const showChangeReasonModal = (showChangeReasonModal, documentId) => {
	return {
		type: SHOW_CHANGE_REASON_MODAL,
		showChangeReasonModal: showChangeReasonModal,
		documentId: documentId
	};
};
